import React from 'react';
import { Card } from 'antd';

import FormAdmon from '../../components/Forms/FormAdmin/FormAdmin';

import styles from './AdminPage.module.css';

export default function AdminPage() {
    return (
        <div className={styles.adminContent}>
            <Card
                style={{
                    width: '50%',
                    minWidth: 250,
                    height: 'fit-content',
                }}
                title='Добавить нового администратора'
            >
                <FormAdmon />
            </Card>
        </div>
    );
}
